import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@common/services/AuthService/AuthService';
import { ModalService } from '@common/services/ModalService/ModalService';
import { TaskService } from '@common/services/TaskService/TaskService';
import { AreaService } from '@common/services/AreaService/AreaService';
import { ClientService } from '@common/services/ClientService/ClientService';
import { TaskDetails } from '@common/models/taskDetails.model';
import { BreadcrumbLevel } from '@common/models/breadcrumbLevel.model';
import { AreaDetails } from '@common/models/areaDetails.model';
import { ClientDetails } from '@common/models/clientDetails.model';

@Component({
  templateUrl: './taskDetailsView.component.html',
  styleUrls: ['./taskDetailsView.component.scss'],
})
export class TaskDetailsViewComponent implements OnInit {
  clientKey: string;
  areaKey: string;
  taskKey: string;
  bottomLevelName: string;
  public taskDetails: TaskDetails = {
    taskName: null,
    taskKey: null,
    employees: [],
    clientKey: null,
    clientName: null,
    areaKey: null,
    areaName: null,
    state: null,
    date: null,
  };
  public breadcrumbLevels: BreadcrumbLevel[] = [];
  public notFound = false;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public authService: AuthService,
    public modalService: ModalService,
    private taskService: TaskService,
    private areaService: AreaService,
    private clientService: ClientService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.clientKey = params['clientKey'];
      this.areaKey = params['areaKey'];
      this.taskKey = params['taskKey'];
      this.getInitialData();
    });
  }

  getClientDetails(): void {
    this.clientService.getClientDetails(this.clientKey)
      .subscribe(
        (data: ClientDetails) => {
          if (data) {
            this.breadcrumbLevels = [
              { clientKey: data.clientKey, clientName: data.clientName },
            ];
          }
        },
        (err) => {},
      );
  }

  getAreaDetails(): void {
    this.areaService.getAreaDetails(this.areaKey)
      .subscribe(
        (data: AreaDetails) => {
          if (data) {
            this.breadcrumbLevels = [
              { clientKey: data.breadcrumbLevels.clientKey, clientName: data.breadcrumbLevels.clientName },
              { areaKey: data.areaKey, areaName: data.areaName },
            ];
          } else {
            this.getClientDetails();
          }
        },
        (err) => {
          this.getClientDetails();
        },
      );
  }

  handleNotFound(): void {
    this.bottomLevelName = '404';
    this.notFound = true;

    this.getAreaDetails();
  }

  getInitialData(): void {
    this.taskService.getTaskDetails(this.taskKey)
      .subscribe(
        (data: TaskDetails) => {
          if (data) {
            this.taskDetails = data;
            this.bottomLevelName = this.taskDetails.taskName;

            this.breadcrumbLevels = [
              { clientKey: this.taskDetails.clientKey, clientName: this.taskDetails.clientName },
              { areaKey: this.taskDetails.areaKey, areaName: this.taskDetails.areaName },
            ];
          } else {
            this.handleNotFound();
          }
        },
        (error) => {
          if (error.status === 404) {
            this.handleNotFound();
          } else {
            this.authService.handleRequestError(error, this.getInitialData.bind(this));
          }
        },
      );
  }

  deleteTask(): void {
    const proceedTaskDeletion = (allTasks?: boolean) => {
      this.modalService.closeModal();
      this.taskService.deleteTask(this.taskKey, allTasks)
        .subscribe(
          (res) => {
            this.modalService.openModal({ type: 'taskDeleted' });
            this.router.navigateByUrl(`/clients/${this.taskDetails.clientKey}/${this.taskDetails.areaKey}`);
          },
          (err) => {
            this.modalService.openModal({ type: 'errorOccurred' });
          },
        );
    };

    if (this.taskDetails.repeat) {
      this.modalService.openModal({
        type: 'deleteRepeatingTask',
        data: this.taskDetails.date,
        callback: proceedTaskDeletion,
      });
    } else {
      this.modalService.openModal({
        type: 'deleteSingleTask',
        callback: proceedTaskDeletion,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clients/views/taskDetailsView/taskDetailsView.component.ts